import { Alert, AlertProps, styled } from "@mui/material";

export const StyledAlert = styled(Alert)({
  "& .MuiAlert-icon": {
    display: "flex",
    alignItems: "center",
  },
  "& .MuiAlert-action": {
    display: "flex",
    alignItems: "center",
  },
  width: "100%",
}) as React.ComponentType<AlertProps>;
